import { formatDistanceToNow, format, isToday, isYesterday } from "date-fns";

export const formatMessageTime = (date) => {
  const d = new Date(date);
  return format(d, "h:mm a");
};

export const formatLastSeen = (date) => {
  if (!date) return "";
  const d = new Date(date);
  if (isToday(d)) return `Today at ${format(d, "h:mm a")}`;
  if (isYesterday(d)) return `Yesterday at ${format(d, "h:mm a")}`;
  return format(d, "MMM d, yyyy");
};

export const formatConversationTime = (date) => {
  if (!date) return "";
  const d = new Date(date);
  if (isToday(d)) return format(d, "h:mm a");
  if (isYesterday(d)) return "Yesterday";
  return format(d, "MMM d");
};

export const getInitials = (name = "") => {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
};

export const getOtherParticipant = (conversation, currentUserId) => {
  return conversation.participants.find((p) => p._id !== currentUserId);
};

export const getConversationName = (conversation, currentUserId) => {
  if (conversation.isGroup) return conversation.groupName;
  const other = getOtherParticipant(conversation, currentUserId);
  return other?.name || "Unknown";
};

export const getConversationAvatar = (conversation, currentUserId) => {
  if (conversation.isGroup) return conversation.groupAvatar;
  const other = getOtherParticipant(conversation, currentUserId);
  return other?.avatar || "";
};

export const isConversationOnline = (conversation, currentUserId, onlineUsers) => {
  if (conversation.isGroup) return false;
  const other = getOtherParticipant(conversation, currentUserId);
  return onlineUsers.includes(other?._id);
};
